<div class="Filter">
    <section class="Filter_Item Filter_Item--Who">
        <form class="Filter_Form" action="#" method="post">
			<label class="Filter_Form_Label" [for]="id + 'target_input'">Кому</label>
			<input class="uk-input uk-form-width-medium"
				[id]="id + 'target_input'"
				type="text"
				name="who"
				placeholder="Кем Вы работаете?"
				[(ngModel)]="targetAudiencesInput"
				(ngModelChange)="triggerFilter($event, 'target')"
			>
		</form>
		<filter-slider modifier="who" collection="targetAudiences"></filter-slider>
    </section>

    <section class="Filter_Item Filter_Item--Where">
        <form class="Filter_Form" action="#" method="post">
			<label class="Filter_Form_Label" [for]="id + 'activity_input'">Куда</label>
			<input class="uk-input uk-form-width-medium"
				[id]="id + 'activity_input'"
				type="text"
				name="where"
				placeholder="Где Вы работаете?"
				[(ngModel)]="activitiesInput"
				(ngModelChange)="triggerFilter($event, 'activity')"
			>
		</form>
		<filter-slider modifier="where" collection="activities"></filter-slider>
    </section>
</div>
